import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../utilities/rtk-query';

interface FreightWebFeaturesFlags {
  freightPermissionsFF: boolean;
  ordersServiceDeadheadMigration: boolean;
  isNewCarrierCapacityEnabled: boolean;
}

/* Feature Flag Slices */

interface FeatureFlagState {
  flags: FreightWebFeaturesFlags;
}

const initialState: FeatureFlagState = {
  flags: {
    freightPermissionsFF: false,
    ordersServiceDeadheadMigration: false,
    isNewCarrierCapacityEnabled: false,
  },
};

export const featureFlagSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<string[]>) => {
      state.flags = {
        freightPermissionsFF: action.payload.includes(
          '8c0995f9ddbfefa867b1d5f6b06263baf82914d0ff22bf209b462f14737b9825'
        ),
        ordersServiceDeadheadMigration: action.payload.includes(
          '9dd6656ae33ba4621f4c8f3a0932175ac9ae1ce556658d84f2bb05d77688b45b'
        ),
        isNewCarrierCapacityEnabled: action.payload.includes(
          '716b7729b4056a20f4afe8b5e36ca35e1b23f58e6845dd8afdce900aae1f7e3a'
        ),
      };
    },
  },
});

/* FeatureFlag Api */

const feautureFlagApi = createApi({
  reducerPath: 'feautureFlagApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.FEATURE_SERVICE_URL!,
  }),
  tagTypes: [],
  endpoints: (builder) => ({
    getUserFeatureFlags: builder.query<string[], string>({
      query: (email: string) => {
        return {
          url: `active?email=${encodeURIComponent(email)}`,
          method: 'GET',
        };
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setFeatureFlags(data));
        } catch (error) {
          console.log('Error handling the featureFlagSlice :>> ', error);
        }
      },
    }),
  }),
});

export const { useGetUserFeatureFlagsQuery } = feautureFlagApi;
export const { setFeatureFlags } = featureFlagSlice.actions;

export default feautureFlagApi;
